import {
  UpdateAirportsActionPayload,
  UpdateDatesActionPayload
} from '../actions/slim-nav';

export interface SlimNavUpdateState {
  airportChanges?: UpdateAirportsActionPayload;
  dateChanges?: UpdateDatesActionPayload;
}
